export default {
  mediaChannel: 'Canal de Mídia',
  allChannels: 'Todos os Canais',
  addNewRestriction: 'Adicionar Nova Restrição',
  newRestrictionTitle: 'Nova Restrição',
  restrictionType: 'Tipo de Restrição',
  exactly: 'Igual',
  lessThan: 'Menor ou igual',
  moreThan: 'Maior ou igual',
  between: 'Entre',
  value: 'Valor',
  minValue: 'Mín',
  maxValue: 'Máx',
  restrictionTimespan: 'Período da Restrição',
  fullPeriod: 'Período Completo',
  customRange: 'Intervalo Personalizado',
  fromDate: 'De',
  toDate: 'Até',
  addRestriction: 'Adicionar Restrição',
  editRestrictionTitle: 'Editar Restrição',
  saveRestriction: 'Salvar',
  edit: 'Editar',
  delete: 'Excluir',
  cancel: 'Cancelar',
  duplicateError: 'Já existe uma restrição idêntica para estes canais e este período',
  combinedRestriction: 'Restrição combinada para: {channels}',
  valueMustBeNonNegative: 'O valor não pode ser negativo',
  maxMustBeGreaterThanMin: 'O máximo deve ser maior que o mínimo',
  mediaChannelRequired: 'Por favor selecione pelo menos um canal de mídia',
  selectDateRange: 'Por favor selecione um intervalo de datas',
  fromDateMustBeBeforeToDate: 'A data de início deve ser anterior à data de fim'
}
